module.exports = __webpack_public_path__ + "img/18_55.93b1f27b.png";